import React from "react";
import { Row, Col, Card, Form, Input, Button, Spin, InputNumber } from "antd";
import { __custom_card } from "../__custom_card";
import {
  SelectBox,
  InputBox,
  isBrowser,
  DatePicker,
} from "../../../../shared/custom-ant-d";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import passwordValidator from "password-validator";
import { formField } from "./_formField";
import { DatePicker as DatePickerBV } from "antd";
import moment from "moment";
import { ZipRegex, PhoneRegex } from "../../../../shared/helpers";

const schema = new passwordValidator();

export const FormPHL = (props) => {
  const {
    form,
    disableAll,
    allCountryList,
    emergencyContactRelationshipList,
    beneficiaryRelationshipList,
    languageList,
    maritalStatusList,
    nameSuffixList,
    salutationList,
    statesList,
    usGenderList,
  } = props;

  const validatePHLFields = (_, value) => {
    let paG_IBIG_Number_PH =
      form.getFieldValue(formField.paG_IBIG_Number_PH) == null ||
      form.getFieldValue(formField.paG_IBIG_Number_PH) === "";
    let philhealtH_Number_PH =
      form.getFieldValue(formField.philhealtH_Number_PH) == null ||
      form.getFieldValue(formField.philhealtH_Number_PH) === "";
    let tiN_PH =
      form.getFieldValue(formField.tiN_PH) == null ||
      form.getFieldValue(formField.tiN_PH) === "";
    let ssS_Number_PH =
      form.getFieldValue(formField.ssS_Number_PH) == null ||
      form.getFieldValue(formField.ssS_Number_PH) === "";

    let regexPattern = {
      pag_ibig: /^[\d]{4}-[\d]{6}-[\d]{2}$/,
      phil_health: /^[\d]{2}-[\d]{9}-[\d]{1}$/,
      tin: /^[\d]{3}-[\d]{3}-[\d]{3}$/,
      sss: /^[\d]{2}-[\d]{7}-[\d]{1}$/,
    };

    if (paG_IBIG_Number_PH && philhealtH_Number_PH && tiN_PH && ssS_Number_PH) {
      return `${_.fullField} is required.`;
    }

    if (value !== null) {
      if (_.field == formField.paG_IBIG_Number_PH) {
        if (regexPattern.pag_ibig.test(value) || value == "") return null;
        else return "Invalid format. Use format NNNN-NNNNNN-NN.";
      }

      if (_.field == formField.philhealtH_Number_PH) {
        if (regexPattern.phil_health.test(value) || value == "") return null;
        else return "Invalid format. Use format NN-NNNNNNNNN-N.";
      }

      if (_.field == formField.tiN_PH) {
        if (regexPattern.tin.test(value) || value == "") return null;
        else return "Invalid format. Use format NNN-NNN-NNN.";
      }

      if (_.field == formField.ssS_Number_PH) {
        if (regexPattern.sss.test(value) || value == "") return null;
        else return "Invalid format. Use format NN-NNNNNNN-N.";
      }
    } else return null;
  };

  return (
    <>
      <Card type="inner">
        <__custom_card title={"Enter name as shown on National ID Card"}>
          <Row justify={"start"}>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="First Name"
                name={formField.legalFirstName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="Middle Name" name={formField.middleName}>
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Last Name"
                name={formField.legalLastName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="Salutation" name={formField.salutation}>
                <SelectBox
                  data={
                    salutationList &&
                    salutationList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  label={""}
                  disabled={disableAll}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !salutationList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="Suffix" name={formField.suffix}>
                <SelectBox
                  data={
                    nameSuffixList &&
                    nameSuffixList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !nameSuffixList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Enter Gender and Marital Status"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Gender"
                name={formField.gender}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    usGenderList &&
                    usGenderList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!usGenderList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Marital Status"
                name={formField.maritalStatus}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    maritalStatusList &&
                    maritalStatusList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !maritalStatusList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Enter Language Skills"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Language"
                name={formField.primaryLanguage}
              >
                <SelectBox
                  data={
                    languageList &&
                    languageList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!languageList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Seconday Language"
                name={formField.secondaryLanguage}
              >
                <SelectBox
                  data={
                    languageList &&
                    languageList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!languageList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Biographical and National ID Information"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Date of Birth"
                name={formField.dob}
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      var now = moment(new Date()); //todays date
                      var end = moment(value); // another date
                      var duration = moment.duration(now.diff(end));
                      var years = duration.asYears();
                      if (years >= 18) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          "You must be 18 years or older to be hired."
                        );
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <DatePickerBV
                    disabled={disableAll}
                    format={"MM/DD/YYYY"}
                    label={""}
                    onChange={(value) => {
                      // form.setFieldsValue({ dob: value })
                    }}
                  />
                ) : (
                  <DatePicker
                    disabled={disableAll}
                    label={""}
                    onChange={(value) => {
                      // form.setFieldsValue({ dob: value })
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Country of Birth"
                name={formField.countryOfBirth}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    allCountryList &&
                    allCountryList.map((item, i) => {
                      return {
                        value: item.countryName,
                        label: item.countryName,
                      };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !allCountryList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Place of Birth (City/Town)"
                name={formField.placeOfBirth}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Nationality"
                name={formField.nationality}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    allCountryList &&
                    allCountryList.map((item, i) => {
                      return {
                        value: item.countryName,
                        label: item.countryName,
                      };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !allCountryList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="National ID Country"
                name={formField.jobReqCountryCode}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={true} />
                ) : (
                  <InputBox disabled={true} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="PAG-IBIG Number"
                name={formField.paG_IBIG_Number_PH}
                dependencies={[
                  formField.philhealtH_Number_PH,
                  formField.tiN_PH,
                  formField.ssS_Number_PH,
                ]}
                rules={[
                  () => ({
                    validator(_, value) {
                      let errorMsg = validatePHLFields(_, value);
                      if (errorMsg !== null) {
                        return Promise.reject(errorMsg);
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="PHILHEALTH Number"
                name={formField.philhealtH_Number_PH}
                dependencies={[
                  formField.paG_IBIG_Number_PH,
                  formField.tiN_PH,
                  formField.ssS_Number_PH,
                ]}
                rules={[
                  () => ({
                    validator(_, value) {
                      let errorMsg = validatePHLFields(_, value);
                      if (errorMsg !== null) {
                        return Promise.reject(errorMsg);
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="TIN"
                name={formField.tiN_PH}
                dependencies={[
                  formField.paG_IBIG_Number_PH,
                  formField.philhealtH_Number_PH,
                  formField.ssS_Number_PH,
                ]}
                rules={[
                  () => ({
                    validator(_, value) {
                      let errorMsg = validatePHLFields(_, value);
                      if (errorMsg !== null) {
                        return Promise.reject(errorMsg);
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="SSS Number"
                name={formField.ssS_Number_PH}
                dependencies={[
                  formField.paG_IBIG_Number_PH,
                  formField.philhealtH_Number_PH,
                  formField.tiN_PH,
                ]}
                rules={[
                  () => ({
                    validator(_, value) {
                      let errorMsg = validatePHLFields(_, value);
                      if (errorMsg !== null) {
                        return Promise.reject(errorMsg);
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Mother's Maiden First Name"
                name={formField.mothersMaidenFirstName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Mother's Maiden Middle Name"
                name={formField.mothersMaidenMiddleName}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Mother's Maiden Last Name"
                name={formField.mothersMaidenLastName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Primary Home Address"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="CountryCode"
                name={formField.countryCode}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item label="Country" name={formField.countryName}>
                <SelectBox
                  data={
                    allCountryList &&
                    allCountryList.map((item, i) => {
                      return {
                        value: item.countryName,
                        label: item.countryName,
                      };
                    })
                  }
                  disabled={true}
                  label={""}
                  onChange={(value) => {
                    var label = allCountryList.filter(
                      (i) => i.countryName == value
                    );
                    form.setFieldsValue({ CountryCode: label[0]?.CountryCode });
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ CountryName: value });
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !allCountryList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="House Number" name={formField.houseNumber}>
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Street/Village/Subdivision/Barangay"
                name={formField.streetVillageSubDivisionBarangay}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="City/Municipality"
                name={formField.cityMunicipality}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="StateID" name={formField.stateID} hidden={true}>
                <Input />
              </Form.Item>
              <Form.Item
                label="Province"
                name={formField.stateName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    statesList &&
                    statesList.map((item, i) => {
                      return { value: item.stateName, label: item.stateName };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  onChange={(value) => {
                    var label = statesList.filter((i) => i.stateName == value);
                    form.setFieldsValue({ StateID: label[0]?.stateID });
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ StateName: value });
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!statesList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Zip Code"
                name={formField.zipCode}
                rules={[
                  { required: true },
                  () => ({
                    validator(_, value) {
                      let isCheck = ZipRegex("PHL");
                      if (!isCheck.regex.test(value)) {
                        return Promise.reject(isCheck.msg);
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Enter Contact Information"}>
          <Row justify="start" gutter={8}>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Mobile/Primary Phone"
                name={formField.mobilePrimaryPhone}
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      let isCheck = PhoneRegex("PHL");
                      if (!isCheck.regex.test(value)) {
                        return Promise.reject(isCheck.msg);
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                  () => ({
                    validator(_, value) {
                      if (value && value.startsWith("0")) {
                        return Promise.reject(
                          "Mobile/Primary Number should not start with 0 digit."
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Secondary Phone"
                name={formField.secondaryPhone}
                rules={[
                  () => ({
                    validator(_, value) {
                      schema.is().not().letters().is().not().symbols();

                      if (value == null) {
                        return Promise.resolve();
                      }

                      if (
                        value != null &&
                        (value.length < 7 || value.length > 10)
                      ) {
                        return Promise.reject(
                          "Secondary Phone must be 7-10 digit number."
                        );
                      } else if (
                        !schema
                          .validate(value, { list: true })
                          .includes("letters") &&
                        !schema
                          .validate(value, { list: true })
                          .includes("symbols")
                      ) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          "Secondary Phone must contain numbers only."
                        );
                      }
                    },
                  }),
                  () => ({
                    validator(_, value) {
                      if (value && value.startsWith("0")) {
                        return Promise.reject(
                          "Secondary Phone should not start with 0 digit."
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Beneficiary Information"}>
          <Card>
            <span>
              This section is for you to indicate your Beneficiary details. For
              each beneficiary you must complete the entire section. A maximum
              of up to 6 beneficiaries can be added. Your total percentage
              allocation for all beneficiaries must equal 100%. If you do not
              wish to add any beneficiary detail, at this time, then you can
              proceed to the next section.
            </span>
          </Card>
          <Form.List
            name="DependentList"
            rules={[
              {
                validator: async (_, dependents) => {
                  if (dependents != undefined && dependents.length > 0) {
                    let pecentTotal = dependents.reduce(function (
                      prev,
                      dependent
                    ) {
                      return (
                        parseFloat(prev) +
                        parseFloat(
                          dependent == undefined || dependent == null
                            ? 0
                            : dependent.BeneficiaryPercentage ?? 0
                        )
                      );
                    },
                    0);

                    if (pecentTotal > 100) {
                      return Promise.reject(
                        `The total sum of percentage(${pecentTotal}%) with all beneficiary should not exceed to 100%.`
                      );
                    }
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }) => (
                  <Card
                    key={key}
                    extra={<MinusCircleOutlined onClick={() => remove(name)} />}
                  >
                    <Row justify="start" gutter={8}>
                      <Col md={{ span: 7, offset: 1 }} xs={24}>
                        <Form.Item
                          {...restField}
                          label={"OnboardingID"}
                          name={[name, "OnboardingID"]}
                          fieldKey={[fieldKey, "OnboardingID"]}
                          initialValue={form.getFieldValue("OnboardingID")}
                          hidden={true}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          label={"First Name"}
                          name={[name, "FirstName"]}
                          fieldKey={[fieldKey, "FirstName"]}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          {isBrowser ? (
                            <Input disabled={disableAll} />
                          ) : (
                            <InputBox disabled={disableAll} />
                          )}
                        </Form.Item>
                      </Col>
                      <Col md={{ span: 7, offset: 1 }} xs={24}>
                        <Form.Item
                          {...restField}
                          label={"Last Name"}
                          name={[name, "LastName"]}
                          fieldKey={[fieldKey, "LastName"]}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          {isBrowser ? (
                            <Input disabled={disableAll} />
                          ) : (
                            <InputBox disabled={disableAll} />
                          )}
                        </Form.Item>
                      </Col>
                      <Col md={{ span: 7, offset: 1 }} xs={24}>
                        <Form.Item
                          {...restField}
                          label={"Middle Name"}
                          name={[name, "MiddleName"]}
                          fieldKey={[fieldKey, "MiddleName"]}
                        >
                          {isBrowser ? (
                            <Input disabled={disableAll} />
                          ) : (
                            <InputBox disabled={disableAll} />
                          )}
                        </Form.Item>
                      </Col>
                      <Col md={{ span: 7, offset: 1 }} xs={24}>
                        <Form.Item
                          {...restField}
                          label={"Date of Birth"}
                          name={[name, "DOB"]}
                          fieldKey={[fieldKey, "DOB"]}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          {isBrowser ? (
                            <DatePickerBV
                              disabled={disableAll}
                              format={"MM/DD/YYYY"}
                              label={""}
                              onChange={(value) => {
                                // form.setFieldsValue({ dob: value })
                              }}
                            />
                          ) : (
                            <DatePicker
                              disabled={disableAll}
                              label={""}
                              onChange={(value) => {
                                // form.setFieldsValue({ dob: value })
                              }}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col md={{ span: 7, offset: 1 }} xs={24}>
                        <Form.Item
                          {...restField}
                          label={"dependentRelationID"}
                          name={[name, "DependentRelationID"]}
                          fieldKey={[fieldKey, "DependentRelationID"]}
                          hidden={true}
                          initialValue={null}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          label={"Relationship"}
                          name={[name, "DependentRelationName"]}
                          fieldKey={[fieldKey, "DependentRelationName"]}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <SelectBox
                            data={
                              beneficiaryRelationshipList &&
                              beneficiaryRelationshipList.map((item, i) => {
                                return {
                                  value: item.expText,
                                  label: item.expText,
                                };
                              })
                            }
                            disabled={disableAll}
                            label={""}
                            showSearch={true}
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            notFoundContent={
                              !beneficiaryRelationshipList ? (
                                <Spin size="small" />
                              ) : null
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col md={{ span: 7, offset: 1 }} xs={24}>
                        <Form.Item
                          {...restField}
                          label={"Beneficiary Percentage"}
                          name={[name, "BeneficiaryPercentage"]}
                          fieldKey={[fieldKey, "BeneficiaryPercentage"]}
                          initialValue={100}
                          rules={[
                            {
                              validator: async (_, value) => {
                                if (typeof value !== "number") {
                                  return Promise.reject(
                                    `Beneficiary Percentage is required.`
                                  );
                                }
                                if (value != undefined) {
                                  if (parseFloat(value) <= 0) {
                                    return Promise.reject(
                                      `The value should not be less than or equal to 0%.`
                                    );
                                  }
                                  return Promise.resolve();
                                }
                              },
                            },
                          ]}
                        >
                          {isBrowser ? (
                            <InputNumber
                              min={0}
                              max={100}
                              formatter={(value) => `${value}%`}
                              disabled={disableAll}
                            />
                          ) : (
                            <InputBox type={"number"} disabled={disableAll} />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                ))}
                <Form.Item>
                  <div style={{ textAlign: "center" }}>
                    <Form.ErrorList errors={errors} />
                  </div>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    disabled={fields.length >= 6}
                  >
                    Add Dependent({6 - fields.length})
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </__custom_card>
        <__custom_card title={"Tell us who to contact in Case of Emergency"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="emergencyContactRelationID1"
                name={formField.emergencyContactRelationID1}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Relationship"
                name={formField.emergencyContactRelationName1}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    emergencyContactRelationshipList &&
                    emergencyContactRelationshipList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  onChange={(value) => {
                    var label = emergencyContactRelationshipList.filter(
                      (i) => i.expText == value
                    );
                    form.setFieldsValue({
                      EmergencyContactRelationID1: label[0]?.codeValueID,
                    });
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ EmergencyContactRelationID1: null });
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !emergencyContactRelationshipList ? (
                      <Spin size="small" />
                    ) : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Name"
                name={formField.emergencyContactName1}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Phone Number"
                name={formField.emergencyContactPhone1}
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      if (value === "") {
                        return Promise.resolve();
                      }

                      var regex = /^[0-9]+$/;
                      if (!regex.test(value)) {
                        return Promise.reject(
                          "Primary Phone must be a number."
                        );
                      } else if (value.length < 7 || value.length > 10) {
                        return Promise.reject(
                          "Primary Phone must be atleast 7-10 digits."
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Email Address"
                name={formField.emergencyContactEmail1}
                rules={[
                  {
                    type: "email",
                    message: "Please input a valid email",
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="emergencyContactRelationID2"
                name={formField.emergencyContactRelationID2}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Relationship"
                name={formField.emergencyContactRelationName2}
              >
                <SelectBox
                  data={
                    emergencyContactRelationshipList &&
                    emergencyContactRelationshipList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  onChange={(value) => {
                    var label = emergencyContactRelationshipList.filter(
                      (i) => i.expText == value
                    );
                    form.setFieldsValue({
                      emergencyContactRelationID2: label[0]?.codeValueID,
                    });
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ emergencyContactRelationID2: null });
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !emergencyContactRelationshipList ? (
                      <Spin size="small" />
                    ) : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="Name" name={formField.emergencyContactName2}>
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Phone Number"
                name={formField.emergencyContactPhone2}
                rules={[
                  () => ({
                    validator(_, value) {
                      if (value === "" || value === undefined) {
                        return Promise.resolve();
                      }

                      var regex = /^[0-9]+$/;
                      if (!regex.test(value)) {
                        return Promise.reject(
                          "Primary Phone must be a number."
                        );
                      } else if (value.length < 7 || value.length > 10) {
                        return Promise.reject(
                          "Primary Phone must be atleast 7-10 digits."
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                labelCol={{ md: { offset: 1 } }}
                wrapperCol={{ md: { span: 24 } }}
                label="Email Address"
                name={formField.emergencyContactEmail2}
                rules={[
                  {
                    type: "email",
                    message: "Please input a valid email",
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
      </Card>
    </>
  );
};
